import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import Row from './Row';

const Table = ({ pageLayout, data, fetchOrders, totalOrders }) => {
  const header = _.get(pageLayout, 'tableHeaders', []).map(
    row => row.fields.title
  );

  return (
    <table className="responsive-table">
      <caption className="responsive-table__caption">
        {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
      </caption>
      <thead className="responsive-table__thead">
        <tr>
          {header.map(label => (
            <th key={`header-salesRepDashboard-${label}`}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody className="responsive-table__tbody">
        {data &&
          data.map((order, index) => (
            <Row
              key={order.id}
              index={index}
              order={order}
              pageLayout={pageLayout}
              fetchOrders={fetchOrders}
              header={header}
            />
          ))}
      </tbody>
    </table>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  totalOrders: PropTypes.number.isRequired
};

export default Table;
